import { axios } from 'api'
import { SyncProductsResponse } from 'api/products'

export type TaskStatus = 'pending' | 'running' | 'completed' | 'failed'

export interface TaskResponse {
  id: string
  type: string
  status: TaskStatus
  source?: string | null
  payload?: Record<string, any> | null
  result?: SyncProductsResponse | Record<string, any> | null
  updateCount?: number
  error?: string | null
  startedAt?: string | null
  completedAt?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}

export interface TasksResponse {
  tasks: TaskResponse[]
}

export interface GetTasksParams {
  type?: string
  status?: TaskStatus
  limit?: number
}

export const getTasks = async (
  params: GetTasksParams = {}
): Promise<TasksResponse> => {
  const response = await axios.get('/tasks', {
    params,
    withCredentials: true
  })

  if (response.status !== 200) {
    throw new Error(response.data?.error || 'Failed to fetch tasks')
  }

  return response.data
}

export const getTask = async (taskId: string): Promise<TaskResponse> => {
  const response = await axios.get(`/tasks/${taskId}`, {
    withCredentials: true
  })

  if (response.status !== 200 && response.status !== 202) {
    throw new Error(response.data?.error || 'Failed to fetch task')
  }

  return response.data
}
